import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { MDBDropdown } from 'mdbreact';
import { routes } from '../../utils/constants';
import TrackWhite from '../../assets/icons/TrackWhite.svg';
import TrackGrey from '../../assets/icons/TrackGrey.svg';
import ViewWhite from '../../assets/icons/ViewWhite.svg';
import ViewGrey from '../../assets/icons/ViewGrey.svg';
import ViewSignedDocumentsGrey from '../../assets/icons/ViewSignedDocumentsGrey.svg';
import ViewSignedDocumentsWhite from '../../assets/icons/ViewSignedDocumentsWhite.svg';
import DownloadWhite from '../../assets/icons/DownloadWhite.svg';
import DownloadGrey from '../../assets/icons/DownloadGrey.svg';
import CancelGrey from '../../assets/icons/CancelGrey.svg';
import DuplicateShipmentGrey from '../../assets/icons/DuplicateShipmentGrey.svg';
import ShipmentInProgressWhite from '../../assets/icons/ShipmentInProgressWhite.svg';
import { Icon as CommonIcon } from '../ReactComponent/Icon';
import { DropdownItem, DropdownItemIcon } from '../ReactComponent/SortableTable/css';
import Actions from '../../assets/icons/Actions.svg';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../_styledComponents/MDBDropdownToggle';
import { ShipmentStatuses } from '../../utils/enums';

const Dropdown = ({
  // eslint-disable-next-line no-unused-vars
  draftActions,
  status,
  cancelShipment,
  probillNumber,
  division,
  shipmentId,
  shipmentNumber,
}) => (
  <MDBDropdown className="dropdown">
    <MDBDropdownToggle className="border-0">
      <CommonIcon iconSrc={Actions} />
    </MDBDropdownToggle>
    <StyledMDBDropdownMenu className="text-white bg-dark" basic>
      {draftActions ? (
        <DropdownItem onClick={() => window.open(`${routes.createShipment}?division=${division}&shipmentId=${shipmentId}`)}>
          <DropdownItemIcon iconSrc={ShipmentInProgressWhite} />
          {t('CompleteDraft')}
        </DropdownItem>
      ) : (
        <>
          <DropdownItem onClick={() => window.open(`${routes.viewShipmentTracking}?division=${division}&probillNumber=${probillNumber}`)}>
            <DropdownItemIcon
              iconSrc={status === ShipmentStatuses.Expired
                            || status === ShipmentStatuses.UnderReview
                            || status === ShipmentStatuses.NotYetPickedUp
                ? TrackGrey : TrackWhite}
            />
            {t('ViewTrackingDetails')}
          </DropdownItem>
          <DropdownItem onClick={() => window.open(`${routes.viewShipment}?division=${division}&probillNumber=${probillNumber}`)}>
            <DropdownItemIcon
              iconSrc={status === ShipmentStatuses.Expired
                        || status === ShipmentStatuses.UnderReview
                        || status === ShipmentStatuses.NotYetPickedUp
                ? ViewGrey : ViewWhite}
            />
            {t('ViewShipmentDetails')}
          </DropdownItem>
          <DropdownItem
            onClick={() => window.open(`${routes.viewShipment}?division=${division}&probillNumber=${probillNumber}&scrollToDocs=true`)}
          >
            <DropdownItemIcon
              iconSrc={status === ShipmentStatuses.Expired
                        || status === ShipmentStatuses.UnderReview
                        || status === ShipmentStatuses.NotYetPickedUp
                ? ViewSignedDocumentsGrey : ViewSignedDocumentsWhite}
            />
            {t('ViewSignedDocuments')}
          </DropdownItem>
          <DropdownItem disabled>
            <DropdownItemIcon iconSrc={status !== ShipmentStatuses.NotYetPickedUp ? DownloadGrey : DownloadWhite} />
            {t('DownloadShippingDocuments')}
          </DropdownItem>
          <DropdownItem
            disabled
            onClick={() => window.open(`${routes.createShipment}
              ?recreate=true&division=${division}
              &probillNumber=${probillNumber}
              &shipmentNumber=${shipmentNumber}`)}
          >
            <DropdownItemIcon iconSrc={DuplicateShipmentGrey} />
            {t('DuplicateShipment')}
          </DropdownItem>
          <DropdownItem disabled onClick={() => cancelShipment()}>
            <DropdownItemIcon iconSrc={CancelGrey} />
            {t('CancelShipment')}
          </DropdownItem>
        </>
      )}
    </StyledMDBDropdownMenu>
  </MDBDropdown>
);

Dropdown.propTypes = {
  draftActions: PropTypes.bool,
  status: PropTypes.oneOf(Object.values(ShipmentStatuses)),
  cancelShipment: PropTypes.func,
  probillNumber: PropTypes.string,
  division: PropTypes.string,
  shipmentId: PropTypes.string,
  shipmentNumber: PropTypes.string,
};

export default Dropdown;
